const Header = () => {
    return (
      <div className="header">
        <h2>DataToExcel</h2>
      </div>
    )
  }
  
  export default Header;
  